export enum PaymentTypeEnum {
  RULE_BASED = 'RULE_BASED',
  FIXED_DATE = 'FIXED_DATE',
}
